export const objectToParamString = (filters: Object, baseUrl?: string): string => {
  let url = baseUrl || '';
  if (filters) {
    for (const [key, value] of Object.entries(filters)) {
      if (!!value) url += `&${key}=${value}`;
    }
  }
  return url;
};
